import { ChipsideComponent } from "../chipside-component";

export class DropdownHeader extends ChipsideComponent {
	constructor() {
		super();

		this.size = this.getAttribute("size") ?? "5";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("chip-header", this.childNodes, { size: this.size }));
	}
}